/**
 * Bosch Logo ASCII Art
 */
const BOSCH_LOGO = `

                        .:-=++***+-.                       
                      .=++++++######*-                     
                     =++++++=--+######*:                   
                   .+++++++: =*..*######:                  
                   =+++++++  =+  =#######.                 
                  :++++++++===+++*#######+                 
                  =+++++++++++############                 
                  =+++++++++++************                 
                                                           
             .:   -===========++++++++++++.  .:            
            :++:  =+++++++++++############  .*#-           
           -++:   -+++++++++++###########*   .+#+.         
          =+=.    :+++++++++++###########=     =#*:        
        .++-      .+++++++++++###########-      :##-       
         =+-       +++++++++++###########:      :##.       
         .++.      =++++++++++###########.     .*#-        
          :++::.   -++++++++++##########*   .:-+#=        
           =++++-  -++++++++++##########+  :##*##.        
          .++. :   :++++++++++##########=   :. *#:       
           =+:     .++++++++++##########-     :#*.        
            .       ++++++++++##########:      .          
                    =+++++++++##########.                 
                    :+++++++++#########+                  
                     =++++++++########*.                  
                      :+++++++#######+.                   
                        :=++++####*=.                     
                           ..:::.                         
                                                     
                                                                           
                   ⚠️  SECURITY NOTICE ⚠️                                 
          This console is for authorized developers only                  
     Unauthorized access attempts are logged and monitored                
                                                                          
                🔒 XSS Protection: ENABLED                                  
                🔒 Console Injection: BLOCKED                               
                🔒 Input Sanitization: ACTIVE    
                ███╗   ███╗███╗   ███╗ █████╗                        
                ████╗ ████║████╗ ████║██╔══██╗                       
                ██╔████╔██║██╔████╔██║███████║                       
                ██║╚██╔╝██║██║╚██╔╝██║██╔══██║                       
                ██║ ╚═╝ ██║██║ ╚═╝ ██║██║  ██║                       
                ╚═╝     ╚═╝╚═╝     ╚═╝╚═╝  ╚═╝                                            
`


export const initializeConsoleSecurity = () => {

    console.log(`%c${BOSCH_LOGO}`, 'font-family: monospace; color: #00A8E1; font-weight: bold;')


    const originalLog = console.log
    const originalWarn = console.warn
    const originalError = console.error
    const originalInfo = console.info

    let suspiciousAttempts = 0
    const MAX_ATTEMPTS = 5


    const isSuspiciousInput = (message) => {
        if (typeof message !== 'string') return false

        const suspiciousPatterns = [
            /eval\s*\(/gi,
            /function\s*\(/gi,
            /new\s+Function/gi,
            /document\.write/gi,
            /innerHTML\s*=/gi,
            /outerHTML\s*=/gi,
            /insertAdjacentHTML/gi,
            /constructor\s*\[/gi,
            /prototype\s*=/gi,
            /Object\.defineProperty/gi,
            /__proto__/gi,
            /window\s*\[/gi,
            /global\s*\[/gi,
            /process\.env/gi,
            /require\s*\(/gi,
            /import\s*\(/gi,
            /fetch\s*\(/gi,
            /XMLHttpRequest/gi
        ]

        return suspiciousPatterns.some(pattern => pattern.test(message))
    }


    const blockSuspiciousInput = (messageArgs) => {
        const messageStr = messageArgs.map(arg => String(arg)).join(' ')
        
        if (isSuspiciousInput(messageStr)) {
            suspiciousAttempts++
            
            const warning = `[SECURITY] Suspicious input detected (Attempt ${suspiciousAttempts}/${MAX_ATTEMPTS}) - Input blocked`
            originalError(
                `%c⚠️  ${warning}`,
                'color: #FF4444; font-weight: bold; font-size: 12px;'
            )
            
            if (suspiciousAttempts >= MAX_ATTEMPTS) {
                originalError(
                    '%c🚨 SECURITY ALERT: Multiple suspicious attempts detected. Access may be restricted.',
                    'color: #FF0000; font-weight: bold; font-size: 14px;'
                )
            }
            
            return true
        }
        
        return false
    }

    console.log = function (...args) {
        if (!blockSuspiciousInput(args)) {
            originalLog.apply(console, args)
        }
    }

    console.warn = function (...args) {
        if (!blockSuspiciousInput(args)) {
            originalWarn.apply(console, args)
        }
    }

    console.error = function (...args) {
        if (!blockSuspiciousInput(args)) {
            originalError.apply(console, args)
        }
    }

    console.info = function (...args) {
        if (!blockSuspiciousInput(args)) {
            originalInfo.apply(console, args)
        }
    }

    Object.defineProperty(window, 'debugger', {
        get() {
            originalWarn('%c⚠️  Debugger access blocked for security reasons', 'color: #FF6600; font-weight: bold;')
            return undefined
        },
        set() {
            originalWarn('%c⚠️  Debugger access blocked for security reasons', 'color: #FF6600; font-weight: bold;')
        }
    })

    originalLog(
        '%c✅ Console Security Protection Initialized',
        'color: #00AA00; font-weight: bold; font-size: 12px;'
    )

    return {
        isSecure: true,
        suspiciousAttempts: () => suspiciousAttempts
    }
}

export default initializeConsoleSecurity
